import { useState } from 'react';
import ToolHelpButton from '../../components/ToolHelpButton';

function formatSessionTitle(session) {
    return session.title && session.title.trim() ? session.title : 'Новый чат';
}

function ChatSidebar({
    workspaceId,
    workspaces = [],
    onWorkspaceChange,
    sessions,
    activeSessionId,
    onSelectSession,
    onCreateSession,
    onDeleteSession,
    onRenameSession,
    loading,
}) {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [editValue, setEditValue] = useState('');

    const startEditing = (session) => {
        setEditingId(session.id);
        setEditValue(formatSessionTitle(session));
    };

    const commitEditing = () => {
        if (editingId) {
            onRenameSession?.(editingId, editValue);
        }
        setEditingId(null);
        setEditValue('');
    };

    const cancelEditing = () => {
        setEditingId(null);
        setEditValue('');
    };

    return (
        <aside className={`chat-sidebar ${isCollapsed ? 'chat-sidebar--collapsed' : ''}`}>
            {!isCollapsed && (
                <div className="chat-sidebar__title">
                    AI Агент
                    <ToolHelpButton toolKey="ai_agent" />
                </div>
            )}
            <button
                type="button"
                className="chat-sidebar__toggle"
                onClick={() => setIsCollapsed((prev) => !prev)}
                aria-expanded={!isCollapsed}
                title={isCollapsed ? 'Развернуть чаты' : 'Свернуть чаты'}
            >
                {!isCollapsed && <span className="chat-sidebar__toggle-label">Чаты</span>}
                <span className="chat-sidebar__toggle-icon" aria-hidden="true">
                    {isCollapsed ? '▸' : '▾'}
                </span>
            </button>
            {!isCollapsed && (
                <>
                    {workspaces.length > 1 && (
                        <label className="crm__workspace chat-sidebar__workspace">
                            Проект
                            <select
                                value={workspaceId || ''}
                                onChange={(event) => onWorkspaceChange?.(event.target.value)}
                            >
                                {workspaces.map((workspace) => (
                                    <option key={workspace.id} value={workspace.id}>
                                        {workspace.name}
                                    </option>
                                ))}
                            </select>
                        </label>
                    )}
                    <button type="button" className="chat-sidebar__new" onClick={onCreateSession}>
                        + Новый чат
                    </button>
                    <div className="chat-sidebar__list">
                        {loading ? (
                            <div className="empty">Загрузка...</div>
                        ) : sessions.length === 0 ? (
                            <div className="empty">Пока нет чатов. Напишите первое сообщение.</div>
                        ) : (
                            sessions.map((session) => (
                                <div
                                    key={session.id}
                                    className={`chat-sidebar__item ${activeSessionId === session.id ? 'active' : ''}`}
                                >
                                    {editingId === session.id ? (
                                        <input
                                            type="text"
                                            className="chat-sidebar__item-input"
                                            value={editValue}
                                            autoFocus
                                            maxLength={200}
                                            onChange={(event) => setEditValue(event.target.value)}
                                            onBlur={commitEditing}
                                            onClick={(event) => event.stopPropagation()}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter') {
                                                    event.preventDefault();
                                                    commitEditing();
                                                } else if (event.key === 'Escape') {
                                                    event.preventDefault();
                                                    cancelEditing();
                                                }
                                            }}
                                        />
                                    ) : (
                                        <button
                                            type="button"
                                            className={activeSessionId === session.id ? 'active' : ''}
                                            onClick={() => onSelectSession(session.id)}
                                            onDoubleClick={(event) => {
                                                event.stopPropagation();
                                                startEditing(session);
                                            }}
                                        >
                                            <span>{formatSessionTitle(session)}</span>
                                        </button>
                                    )}
                                    {editingId !== session.id && (
                                        <button
                                            type="button"
                                            className="chat-sidebar__item-rename icon-button"
                                            title="Переименовать чат"
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                startEditing(session);
                                            }}
                                        >
                                            ✎
                                        </button>
                                    )}
                                    <button
                                        type="button"
                                        className="chat-sidebar__item-delete icon-button"
                                        title="Удалить чат"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            onDeleteSession(session.id);
                                        }}
                                    >
                                        ×
                                    </button>
                                </div>
                            ))
                        )}
                    </div>
                </>
            )}
        </aside>
    );
}

export default ChatSidebar;
